// services/coursesMockFlag.ts
//
// The Courses V1 dev fixture switch, on its own so the instance hooks every
// screen reads (`useIsCourseStudent`) do not pull the course service in.

/** True only in dev builds that opted into the fixture. */
export const isCoursesMockEnabled = (): boolean =>
  import.meta.env.DEV && import.meta.env.VITE_COURSES_MOCK === 'true';
